import reducer from "./slice";

export { closeMenu, setActiveMenu, SideMenus } from "./slice";

export * from "./selectors";
export default reducer;
